import React, {ComponentType} from 'react';
import {connect} from 'react-redux';
import NotFound from '../modules/not-found';
import {Profile} from 'feedback-system/dto/IProfile';

interface Store {
    authenticated: Profile;
}

interface State {
    isAuth: boolean;
}

interface Props {
    auth: Profile;
}

export default (ComposedComponent: ComponentType<{}>, needRoles: string[]) => {
    class Authenticate extends React.Component<Props, State> {
        state = {
            isAuth: true
        };

        componentDidMount() {
            this._checkRoles();
        }

        _checkRoles() {
            const found = this.props.auth.roles.some((r: string) => needRoles.includes(r));
            this.setState({
                isAuth: found
            });
        }

        render() {
            return <>{this.state.isAuth ? <ComposedComponent {...this.props} /> : <NotFound />}</>;
        }
    }

    const mapStateToProps = (state: Store): Props => ({
        auth: state.authenticated
    });

    return connect(mapStateToProps)(Authenticate);
};
